import {
  API_ROUTES,
  payrollLiabilitiesSchema,
  payrollRunSchema,
  type SavePayrollRunRequest,
} from '@hvac/contracts';
import { queryOptions } from '@tanstack/react-query';
import { z } from 'zod';
import { apiClient } from './queries.js';

export const payrollKeys = {
  all: (organizationId: string) => ['payroll', organizationId] as const,
  runs: (organizationId: string) => ['payroll', organizationId, 'runs'] as const,
  liabilities: (organizationId: string) => ['payroll', organizationId, 'liabilities'] as const,
};

export const payrollRunsQuery = (organizationId: string) =>
  queryOptions({
    queryKey: payrollKeys.runs(organizationId),
    queryFn: ({ signal }) =>
      apiClient.request({
        path: API_ROUTES.payroll.list(organizationId),
        schema: z.array(payrollRunSchema),
        signal,
      }),
    staleTime: 15_000,
  });

export const payrollLiabilitiesQuery = (organizationId: string) =>
  queryOptions({
    queryKey: payrollKeys.liabilities(organizationId),
    queryFn: ({ signal }) =>
      apiClient.request({
        path: API_ROUTES.payroll.liabilities(organizationId),
        schema: payrollLiabilitiesSchema,
        signal,
      }),
    staleTime: 15_000,
  });

export const savePayrollRun = (
  organizationId: string,
  runId: string | null,
  body: SavePayrollRunRequest,
) =>
  apiClient.request({
    method: runId === null ? 'POST' : 'PATCH',
    path:
      runId === null
        ? API_ROUTES.payroll.list(organizationId)
        : API_ROUTES.payroll.byId(organizationId, runId),
    schema: z.object({ runId: z.string() }),
    body,
  });

export const postPayrollRun = (organizationId: string, runId: string) =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.payroll.post(organizationId, runId),
    schema: z.object({ journalEntryId: z.string().nullable() }),
  });

export const voidPayrollRun = (organizationId: string, runId: string, reason: string) =>
  apiClient.request({
    method: 'POST',
    path: API_ROUTES.payroll.void(organizationId, runId),
    schema: z.undefined(),
    body: { reason },
  });
